import { JsonServiceClient } from "@servicestack/client";
import "rxjs/add/observable/from";
import * as CreDtos from "../CRE.dtos";

export const fileApi = {
    upload: (files: any, isImage: boolean) => {
        return new Promise<CreDtos.UploadTemporaryFileResponse>((resolve, reject) => {
            var client = new JsonServiceClient("");
            var parameters = new CreDtos.UploadTemporaryFile();
            parameters.isImage = isImage;
            const formData = new FormData();
            formData.append('files[]', files[0], files[0].name);
            formData.append('isImage', isImage.toString());
            client.postBody(parameters, formData).then(r => {
                resolve(r);
            }).catch(x => {
                reject(x)
            });
        });

    }
};


// WEBPACK FOOTER //
// ./src/services/file.service.ts